import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import "./style.scss";

const settings_carousel = {
  dots: true,
  infinite: true,
  slidesToShow: 1, // 显示几张幻灯片
  slidesToScroll: 1, // 幻灯片一次滚动几张
  arrows: false,
  autoplay: true,
  // speed: 2000,
  autoplaySpeed: 2000,
  // cssEase: "linear",
  appendDots: (dots: any) => <ul> {dots} </ul>,
};

function Carousel(props: any) {
  const { id, list, compId, mark, pId, mallTest, _pvMoudel, _adMoudel } = props;
  const [index, setIndex] = useState<any>(null);
  const [cImgH, setCImgH] = useState<any>("auto");
  const extendParams = {
    ...dd.ep,
    providerId: pId,
    compId,
    mallTest,
  };

  const clickCarousel = (v: any) => {
    let _ep = {
      ...extendParams,
      linkUrl: v.link,
      positionId: v.key,
    };
    _ep = utils.formatParams(_ep);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_lunbo_click",
      dd.baseParams,
      _ep
    );
    if (v.link) {
      const moudels = `?sourceid=200001&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
      window.location.href = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
        navigator.userAgent
      )
        ? `https://m.autohome.com.cn/${moudels}`
        : utils.linkUrl(v.link, 200001, mallTest);
    }
  };

  // 公共埋点函数
  const commonBPointFn = (_i: number) => {
    let _ep = {
      ...extendParams,
      positionId: _i + 1,
      linkUrl: list[_i].link,
    };
    _ep = utils.formatParams(_ep);
    utils.pvTrackLogger("show", "ec_topic_mall_lunbo_show", dd.baseParams, _ep);
  };

  // 轮播图每一帧曝光
  const afterChange = (i: any) => {
    // 记录轮播图下标，页面切换回来时曝光对应轮播图埋点
    setIndex(() => i);
    if (mark.pageType === "mall") {
      // 曝光埋点
      commonBPointFn(i);
    }
  };

  // 第一张图片只曝光一次
  useEffect(() => {
    if (list.length > 0 && mark.pageType === "mall") {
      // 曝光埋点
      let _ep = {
        ...extendParams,
        positionId: 1,
        linkUrl: list[0].link,
      };
      _ep = utils.formatParams(_ep);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_lunbo_show",
        dd.baseParams,
        _ep
      );
    }
  }, []);

  // 页面切换回来时曝光当前轮播图埋点
  useEffect(() => {
    if (mark.pageType === "mall" && typeof index === "number") {
      // 曝光埋点
      commonBPointFn(index);
    }
  }, [JSON.stringify(mark)]);

  useEffect(() => {
    // @ts-ignore
    const cImgH = document.getElementById("item-carousel")?.offsetWidth * 0.47;
    if (cImgH > 0) {
      setCImgH(() => cImgH);
    }
    // @ts-ignore
  }, [document.getElementById("item-carousel")?.offsetWidth]);

  return (
    <Slider
      key={id}
      {...settings_carousel}
      className="tabHome-item tabHome-item-radious"
      afterChange={(index: any) => afterChange(index)}
    >
      {list.map((v: any, k: number) => {
        return (
          <img
            id="item-carousel"
            className="item-carousel"
            key={v.key}
            src={v.picture}
            onClick={() => clickCarousel(v)}
            style={{ height: cImgH }}
          />
        );
      })}
    </Slider>
  );
}

export default Carousel;
